module.exports = __webpack_public_path__ + "static/media/arts_7.c32ddc43.jpg";